import { useState } from 'react'

import { ReportFrequency, getAiAnalyticsReport } from 'core'

import { downloadCSV } from '../../../common'
import { Button, Card, Col, Row } from '../../../common/components'
import DatePicker from '../../../common/components/dataEntry/components/DatePicker'
import { now } from '../../../common/dateFormatters'
import { useQueryRequestV2 } from '../../../common/hooks'

interface AiAnalyticsReportSectionProps {
  name: string
}

const AiAnalyticsReportSection = ({ name }: AiAnalyticsReportSectionProps) => {
  const [loading, setLoading] = useState<boolean>(false)

  const [startDate, setStartDate] = useState<string>(null)
  const [endDate, setEndDate] = useState<string>(null)

  const { isLoading, sendQuery } = useQueryRequestV2<any>()

  const handleStartDateChange = (date: any, dateString: string) => {
    setStartDate(dateString)
  }

  const handleEndDateChange = (date: any, dateString: string) => {
    setEndDate(dateString)
  }
  const handleMonthlySubmit = async () => {
    await handleSubmit(ReportFrequency.Monthly)
  }
  const handleWeeklySubmit = async () => {
    await handleSubmit(ReportFrequency.Weekly)
  }
  const handleSubmit = async (frequency: ReportFrequency) => {
    setLoading(true)
    const result = await sendQuery(() => getAiAnalyticsReport({ startDate: startDate, endDate: endDate }))
    if (result) {
      downloadCSV(result, `ai_analytics${startDate}.csv`)
    }
    setLoading(false)
  }

  return (
    <Card title={name}>
      <Row className="mt-16">
        <Col span={8}>
          <DatePicker
            placeholder="Start Date"
            className="w-100"
            format={'MM/DD/YYYY'}
            onChange={handleStartDateChange}
            allowClear={false}
            disabledDate={(d) => !d || d.isAfter(now())}
          ></DatePicker>
        </Col>
        <Col span={8}>
          <DatePicker
            placeholder="End Date"
            className="w-100"
            format={'MM/DD/YYYY'}
            onChange={handleEndDateChange}
            allowClear={false}
            disabledDate={(d) => !d || d.isAfter(now())}
          ></DatePicker>
        </Col>
      </Row>
      <Row className="mt-16">
        <Col span={4}>
          <Button type="primary" disabled={!startDate || !endDate} loading={loading} onClick={handleMonthlySubmit}>
            Download Report
          </Button>
        </Col>
      </Row>
    </Card>
  )
}

export default AiAnalyticsReportSection
